var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telegran"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.443 6.02695L18.4249 20.2604C18.1972 21.2649 17.6034 21.5149 16.7596 21.0417L12.1609 17.653L9.94199 19.7871C9.69643 20.0327 9.49105 20.238 9.0178 20.238L9.34819 15.5546L17.8713 7.853C18.2418 7.52262 17.7909 7.33957 17.2953 7.66995L6.75867 14.3045L2.22255 12.8847C1.23585 12.5766 1.218 11.898 2.42793 11.4248L20.1706 4.58932C20.9921 4.28126 21.7109 4.77237 21.443 6.02695Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramShare);
export default __webpack_public_path__ + "static/media/TelegramShare.c50cb6dfd85350a0ffc8cadc40c9426c.svg";
export { ForwardRef as ReactComponent };